module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABTklEQVRYR+2W7W3CMBCG8QZsQDsBjBA2gAmADdiAMAkwQdkAmKDdANgAJgjPSRfJ6o/6/KFGICydHCmO3+fe80dcr+PmOtbvvQFe04GmaT6ccxfL+iruAOI1wisATHObBlkykTGIb+lmxAJ9eQ62YgAqPkFxaRUXumwAhPvMcyA+iQrxn2Da3oAsgFzxLAcQHzHBF3EnJtZV/9udJAdUXGy/qu23GNv9sdEAiFea+Yl+TubJ4tElQHzORxtih7A8ZzezA3K6oXYuKR7lgNb9m4+mZL/PTl0nMDsg41NOuhBoFIBC1PQrosaJdUgg9D4aQCHaxbgFYhES+et9EoBCVPSyFtp1kbQdkwEUQk7Do+6OccqZkAWgEHIZCcSAEIj/u4za2uqlJOUY6jYVIFPLdsBXSdmmRQH8bdrJL5lXku5+Sk2F9wYVL8Eb4OkceADIkW8hn/RFxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = 228
// module chunks = 0